export type TefapConfig = { [key: string]: TefapStateConfig };

export type TefapStateConfig = {
  name: string;
  rows: TefapConfigIncome[];
  programs: TefapConfigStateProgram[];
};

export type TefapConfigIncome = {
  size: number;
  income: string;
};

export type TefapConfigStateProgram = {
  id: number;
  name: string;
  acronym: string;
  state: string;
};
